export default __webpack_public_path__ + "static/PromptIconThree-676e9c9e02c9975f939ce0d29e61a2f9.png";